import {
  observable,
  action,
} from 'mobx';
import { OUTPUT_TTL } from '../constants/Pac';

class DiagnoseStore {
  @observable
    isTesting = false;
  @observable
    editedChanel = null;
  @observable
    editedMeter = null;
  @observable
    editedAnalogInput = null;
  @observable
    editedAnalogOutput = null;

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  get pac() {
    const { isDemo } = this.rootStore.batchStore;
    return isDemo ? this.rootStore.pacSimulatorStore : this.rootStore.pacStore;
  }

  @action
    setOutput = (port, value = '1') => {
      const { canEmit } = this.rootStore.batchStore;

      if (!canEmit) {
        return;
      }

      this.pac
        .runWS(`set-output ${port}=${value === '1' ? OUTPUT_TTL : value}`);
    };

  @action
    setInput = (port, value = '1') => {
      const { batchStore, pacSimulatorStore } = this.rootStore;
      const { canEmit, isDemo } = batchStore;

      if (!canEmit || !isDemo) {
        return;
      }

      pacSimulatorStore.setInputs(port, value);
    };

  @action
    setAllOutputs = value => {
      const params = Array(96)
        .fill(value)
        .map((v, key) => `${key + 1}=${v === '1' ? OUTPUT_TTL : v}`)
        .join(' ');
      this.pac.runWS(`set-outputs ${params}`);
    };

  @action
    startOutputTest = () => {
      let port = 0;
      const { outputs } = this.rootStore.batchStore;
      this.isTesting = true;
      this.testingOutputInterval = setInterval(() => {
        port += 1;
        if (port > 96) {
          this.stopOutputTest();
          return;
        }

        this.setOutput(port, outputs[port - 1] === '1' ? '0' : '1');
      }, 1000);
    };

  @action
    stopOutputTest = () => {
      this.isTesting = false;
      clearInterval(this.testingOutputInterval);
    };

  @action
    editChanel = (port) => {
      const { batchStore } = this.rootStore;
      if (batchStore.isDemo) {
        this.editedChanel = this.editedChanel !== port ? port : null;
      }
    };

  @action
    saveChanelValue = (e) => {
      const { batchStore, pacSimulatorStore } = this.rootStore;
      const value = e.target.value || 0;
      if (batchStore.isDemo && e.keyCode === 13) { // on enter
        pacSimulatorStore.setWeight(this.editedChanel, value);
      }
    };

  @action
    editMeter = (port) => {
      const { batchStore } = this.rootStore;
      if (batchStore.isDemo) {
        this.editedMeter = this.editedMeter !== port ? port : null;
      }
    };

  @action
    setMeterStatus = (port) => {
      const { batchStore, pacSimulatorStore } = this.rootStore;
      if (batchStore.isDemo) {
        pacSimulatorStore.setMeterStatus(port, !batchStore.hasPumpFinished(port));
      }
    };

  @action
    saveMeterValue = (e) => {
      const { batchStore, pacSimulatorStore } = this.rootStore;
      const value = e.target.value || 0;
      if (batchStore.isDemo && e.keyCode === 13) { // on enter
        pacSimulatorStore.setMeter(this.editedMeter, value);
      }
    };

  @action
    editAnalogInput = (port) => {
      const { batchStore } = this.rootStore;
      if (batchStore.isDemo) {
        this.editedAnalogInput = this.editedAnalogInput !== port ? port : null;
      }
    };

  @action
    saveAnalogInputValue = (e) => {
      const { batchStore, pacSimulatorStore } = this.rootStore;
      const value = e.target.value || 0;
      if (batchStore.isDemo && e.keyCode === 13) { // on enter
        pacSimulatorStore.setAnalogInput(this.editedAnalogInput, value);
      }
    };

  @action
    editAnalogOutput = (port) => {
      const { batchStore } = this.rootStore;
      if (batchStore.isDemo) {
        this.editedAnalogOutput = this.editedAnalogOutput !== port ? port : null;
      }
    };

  @action
    saveAnalogOutputValue = (e) => {
      const { batchStore, pacSimulatorStore } = this.rootStore;
      const value = e.target.value || 0;
      if (batchStore.isDemo && e.keyCode === 13) { // on enter
        pacSimulatorStore.setAnalogOutput(this.editedAnalogOutput, value);
      }
    };
}

export default DiagnoseStore;
